<script setup lang="ts">
const emit = defineEmits([ 'zoom-in', 'zoom-out' ]);
</script>

<template>
  <div class="zoom-map-buttons">
    <button class="map-zoom-in" @click.native="emit('zoom-in')" />
    <button class="map-zoom-out" @click.native="emit('zoom-out')" />
  </div>
</template>
